import styled from "styled-components";

export const FestivalMainInterviewWrapper = styled.div`
  padding: 0 16px;
`;

export const FestivalMainInterviewTop = styled.div`
  height: 210px;
  border-radius: 8px;
  background-image: url(/image-web/rabbit/rank-banner.png);
  background-size: cover;
  background-repeat: no-repeat;
  color: #fff;
  position: relative;

  > img {
    width: 200px;
    position: absolute;
    bottom: 0;
    right: 15px;
    z-index: 0;
  }
`;

export const FestivalMainInterviewTopText = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 20px 12px;
  height: 100%;
  z-index: 1;
  position: relative;

  > .title {
    font-family: esamanru;
    font-weight: 700;
    font-size: 20px;
  }

  > .name {
    border-radius: 8px;
    padding: 8px;
    background: #6436e7;
    width: max-content;
    white-space: nowrap;
    font-weight: 700;
    font-size: 18px;
  }
`;

export const FestivalMainInterviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;

  > .title {
    font-weight: 700;
    font-size: 18px;
  }
`;

export const FestivalMainInterviewGrid = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 12px;
  position: relative;
`;

export const FestivalMainInterviewItem = styled.div`
  background: #121212;
  aspect-ratio: 1 / 1;
  border-radius: 8px;
  position: relative;

  > img {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 0;
    border-radius: 8px;
  }

  > .back {
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 8px;
    top: 0;
    z-index: 0;
    background: linear-gradient(
      180deg,
      rgba(18, 18, 18, 0) 51.08%,
      #121212 85.49%
    );
  }
`;

export const FestivalMainInterviewItemText = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 20px 12px;
  height: 100%;
  color: #fff;
  z-index: 1;
  position: relative;

  > .title {
    font-family: esamanru;
    font-weight: 700;
    font-size: 20px;
  }

  > .name {
    font-weight: 700;
    font-size: 16px;
  }
`;
